import React, { Fragment, useState, type ReactNode } from "react";
import { Box } from "@mui/material";
import RpMUIDialog from "@/components/modals/RpMUIModal";
import ImageRP from "@/components/ImageRP";
import {
  RRD_LAYOUT_KEY,
  normalizeRRDPrintTypeContext,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdLayoutHelper";
import RRDDirectMailTemplate from "../common/rrdTemplate/RRDDirectMailTemplate";

type ViewRRDLocationTemplateProps = {
  templateImage?: string;
  children?: ReactNode;
  heroImages?: any[];
  couponImages?: any[];
  fixedImages?: any[];
  printType?: string;
  layoutKey?: string;
  frontCouponExpiryDate?: string;
  backCouponExpiryDate?: string;
};

const ViewRRDLocationTemplate = ({
  templateImage,
  children,
  heroImages = [],
  couponImages = [],
  fixedImages = [],
  printType,
  layoutKey,
  frontCouponExpiryDate,
  backCouponExpiryDate,
}: ViewRRDLocationTemplateProps) => {
  const [open, setOpen] = useState(false);

  const resolvedLayoutKey = normalizeRRDPrintTypeContext({
    print_type: printType,
    layoutKey,
  }).layoutKey;
  const hasPreviewData =
    heroImages?.length > 0 && (resolvedLayoutKey || printType);

  const handleOpen = () => templateImage && setOpen(true);
  const handleClose = () => setOpen(false);

  if (!templateImage) return null;

  const imageSrc =
    templateImage.startsWith("/") || templateImage.startsWith("http")
      ? templateImage
      : `/${templateImage}`;

  const modalMaxWidth =
    resolvedLayoutKey === RRD_LAYOUT_KEY.VALUE_SHEET_INSERT_2H_12C
      ? "md"
      : "sm";

  return (
    <Fragment>
      <Box
        onClick={handleOpen}
        sx={{
          cursor: "pointer",
          display: "inline-block",
          "&:hover": { opacity: 0.8 },
        }}
        title="Click to view template"
      >
        {children || (
          <ImageRP
            src={imageSrc}
            type="HYPER_PLACEHOLDER"
            alt="Template"
            className="img-fluid rounded campaign-image"
          />
        )}
      </Box>

      <RpMUIDialog
        open={open}
        onClose={handleClose}
        maxWidth={modalMaxWidth}
        heading="Preview"
      >
        {hasPreviewData ? (
          <Box sx={{ p: 2 }}>
            <RRDDirectMailTemplate
              heroImages={heroImages}
              coupons={couponImages}
              fixedImages={fixedImages}
              printType={printType}
              layoutKey={resolvedLayoutKey}
              frontCouponExpirationDate={frontCouponExpiryDate}
              backCouponExpirationDate={backCouponExpiryDate}
              readOnly
              fullWidth
            />
          </Box>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            sx={{ p: 2, alignItems: "center" }}
          >
            <ImageRP
              src={imageSrc}
              alt="Template"
              type="HYPER_PLACEHOLDER"
              className="img-fluid rounded campaign-image"
              style={{ objectFit: "none", overflow: "hidden" }}
            />
          </Box>
        )}
      </RpMUIDialog>
    </Fragment>
  );
};

export default ViewRRDLocationTemplate;
